/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";

import { useProducts } from "api/hooks";
import ProductsTableView from "components/views/ProductTableView";

const ProductsList = ({ className }) => {
  const classes = ["ProductsList"];
  if (className) classes.push(className);

  const { data } = useProducts();

  return <ProductsTableView list={data} />;
};

ProductsList.displayName = "ProductsList";

ProductsList.propTypes = {
  className: PropTypes.string,
};

ProductsList.defaultProps = {
  className: null,
};

export default ProductsList;
